import { useMutation } from "@/compat/reactQuery";
import templateFormHistoryService from "../../services/templateFormHistoryService";

const useAddTemplateFormHistoryAttachment = () => useMutation(templateFormHistoryService.addHistoricAttachment)

export default useAddTemplateFormHistoryAttachment;